import React from 'react';
import { ConfigurationCardModel as ModelConfigurationCardModel } from '../../productModelConfigurations/models/productModelConfigurationCard.model';
import { ConfigurationCardModel as SeriesConfigurtionCardModel } from '../../productSeriesDetailConfigurationsOverview/models/productSeriesConfigurationCard.model';
import Picture from '../picture';

const MediaElement = ({
  model,
  pictureClassName = '',
}: {
  model: ModelConfigurationCardModel | SeriesConfigurtionCardModel;
  pictureClassName: string;
}): JSX.Element => {
  const externalThumbnail = {
    url: model.getExternalThumbnail,
    height: 720,
    width: 1280,
  };

  return (
    <Picture
      productImageProps={{
        desktopRendition: externalThumbnail.url ? externalThumbnail : model.firstAsset?.rendition_desktop_size500,
        mobileRendition: externalThumbnail.url ? externalThumbnail : model.firstAsset?.rendition_mobile_size500,
        alt: model.assets?.[0]?.alt,
        isVideoThumbnail: !!model.getVideoUrl,
        ...(!model.getVideoUrl && { pictureClassName }),
      }}
    />
  );
};

export default MediaElement;
